export const LoadingBlock = ({
  title,
  message,
}: {
  title: string;
  message: string;
}) => (
  <div className="flex flex-col items-center justify-center text-center gap-6 px-8 py-16 border-y border-ink/10 bg-stone-50/50">
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-burgundy/20 border-t-burgundy" aria-hidden />
    <h2 className="text-2xl font-display font-semibold text-ink">{title}</h2>
    <p className="text-stone-700 max-w-[650px] leading-relaxed text-lg">{message}</p>
  </div>
);
